import React from 'react';
interface FormFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  type?: 'text' | 'email';
  multiline?: boolean;
  autoComplete?: string;
  inputRef?: (el: HTMLInputElement | HTMLTextAreaElement | null) => void;
}
export function FormField({
  id,
  label,
  value,
  onChange,
  error,
  type = 'text',
  multiline = false,
  autoComplete,
  inputRef
}: FormFieldProps) {
  const errorId = `${id}-error`;
  const shared = {
    id,
    name: id,
    value,
    required: true,
    'aria-required': true,
    'aria-invalid': Boolean(error),
    'aria-describedby': error ? errorId : undefined,
    className: `block w-full rounded-[3px] border bg-surface px-4 text-[16px] text-ink transition-colors duration-150 ease-out placeholder:text-ink-muted focus:border-ink focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 ${error ? 'border-danger' : 'border-line-strong'}`
  };
  return <div data-id="element-540" data-mp="1xxvc4hwsg4ae">
      <label htmlFor={id} className="block text-[14px] font-medium text-ink" data-id="element-541" data-mp="1xxlm4ubqtx4p">
        {label} <span className="font-normal text-ink-muted" data-id="element-542" data-mp="1sztum1f0gd11">(required)</span>
      </label>
      <div className="mt-2" data-id="element-543" data-mp="26z1xp5eao5ai">
        {multiline ? <textarea {...shared} ref={inputRef} rows={6} onChange={e => onChange(e.target.value)} className={`${shared.className} min-h-[160px] py-3`} data-id="element-544" data-mp="270mr2rovhi6s" /> : <input {...shared} ref={inputRef} type={type} autoComplete={autoComplete} onChange={e => onChange(e.target.value)} className={`${shared.className} h-12`} data-id="element-545" data-mp="2by64jpdqxqxo" />}
      </div>
      {error && <p id={errorId} className="mt-2 text-[14px] text-danger" data-id="element-546" data-mp="2lqbuktkftya8">
          {error}
        </p>}
    </div>;
}